import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";

const GuestMenu = ({ onTrigger }) => {
    const [open, setOpen] = useState(false);
    const [mounted, setMounted] = useState(false);

    const openSideMenu = () => {
        setMounted(true);
        requestAnimationFrame(() => setOpen(true));
    };

    const closeSideMenu = () => setOpen(false);

    useEffect(() => {
        if (onTrigger) onTrigger(openSideMenu);
    }, [onTrigger]);

    useEffect(() => {
        if (open) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    useEffect(() => {
        if (!open && mounted) {
            const t = setTimeout(() => setMounted(false), 360);
            return () => clearTimeout(t);
        }
    }, [open, mounted]);

    if (!mounted) return null;

    return createPortal(
        <div
            className={`side-menu-overlay ${open ? "open" : ""}`}
            role="dialog"
            aria-hidden={!open}
            onClick={closeSideMenu}
        >
            <aside className="side-menu" onClick={(e) => e.stopPropagation()}>
                <button
                    className="side-menu-button-close"
                    onClick={closeSideMenu}
                    aria-label="close"
                ></button>
                <div className="side-menu-list">
                    <a href="/" className="side-menu-text">
                        ГЛАВНАЯ
                    </a>
                    <a
                        href="https://forum.medieval-rp.net/"
                        className="side-menu-text"
                        target="_blank"
                        rel="noreferrer"
                    >
                        ФОРУМ
                    </a>
                    <a
                        href="https://wiki.medieval-rp.net/"
                        className="side-menu-text"
                        target="_blank"
                        rel="noreferrer"
                    >
                        WIKI
                    </a>
                </div>
                <div className="side-menu-social-icons-container">
                    <a
                        href="https://vk.com/medievalrpnet"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <button className="vk-icon" aria-label="vk"></button>
                    </a>
                    <a
                        href="https://t.me/medieval_rp"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <button
                            className="telegram-icon"
                            aria-label="tg"
                        ></button>
                    </a>
                </div>
            </aside>
        </div>,
        document.body,
    );
};

export default GuestMenu;
export { GuestMenu };
